import React from 'react';
import { useComputedColorScheme, useMantineColorScheme } from '@mantine/core';

type Theme = 'light' | 'dark';

// Light and dark mode are Mantine's colour scheme (remembered in
// localStorage). This keeps the `useTheme()` shape the pages already use.
export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <>{children}</>;

export const useTheme = (): { theme: Theme; toggleTheme: () => void } => {
  const { setColorScheme } = useMantineColorScheme();
  // The scheme on screen, with "auto" resolved to light or dark.
  const theme = useComputedColorScheme('light');

  return {
    theme,
    toggleTheme: () => setColorScheme(theme === 'dark' ? 'light' : 'dark'),
  };
};
